import { Sprite, Texture } from 'pixi.js';
import Lerper from '../../../../utils/Lerper';

export class TileStackShadow extends Sprite {
  private readonly shadowLerper: Lerper;

  constructor() {
    super(Texture.from('tile_shadow_opaque'));

    this.anchor.set(0.6, 0.7);
    this.alpha = 0;

    this.shadowLerper = new Lerper({
      displayObject: this,
      initValue: 0,
      lerp: 0.2,
      onChange: (value): void => {
        if (!this) return;
        this.alpha = value;
      },
    });
  }

  public update(tileCount: number): void {
    if (!this || !this.shadowLerper) return;
    const target = Math.min(1, tileCount / 3) * 0.2;
    this.shadowLerper.setTarget(target);
  }
}
